/**
 * Created by mnaughton on 12/3/2015.
 */

//import config from 'config/default';
//import UrlBuilder from '@HBKEngineering/url-builder';
var UrlBuilder = require("@HBKEngineering/url-builder");

function UrlService() {
  this.rootBuilder = new UrlBuilder("");
  this.apiBuilder = new UrlBuilder("");
}

UrlService.prototype = {
  /**
   * True when the service has been initialized, otherwise false.
   * @type Boolean
   */
  initialized: false,

  /**
   * The absolute URL of the API root with trailing slash.
   * @type String
   */
  apiRoot: "",

  /**
   * Initializes the UrlService
   * @param {String} apiRoot The absolute API location
   */
  initialize: function (apiRoot) {
    this.apiRoot = apiRoot;
    this.apiBuilder = new UrlBuilder("", apiRoot);
    this.initialized = true;
  },

  /**
   * @type UrlBuilder
   */
  rootBuilder: new UrlBuilder(""),
  /**
   * @type UrlBuilder
   */
  apiBuilder: new UrlBuilder(""),

  /**
   * Normalizes a URL for the various deployment configurations.
   * @param  {string} path         The path to normalize.
   * @param  {Boolean} [leadingSlash] True to include a leading slash, otherwise false. If unspecified, the input path will be examined, and its leading slash, or lack thereof, will be preserved. The trailing slash state is always preserved.
   * @return {String}              The normalized URL.
   * @example
   * UrlService.url('/some/other/place');
   * //returns '/some/other/place' when running at root.
   * UrlService.url('some/other/place', true);
   * //returns '/some/other/place' when running at root
   * UrlService.url('');
   * //returns '/' when running at root.
   * UrlService.url('/somewhere', true, true);
   * //returns '/somewhere'
   * UrlService.url('some/other/place', false);
   * //returns "some/other/place"
   */
  url: function (path, leadingSlash) {
    return this.rootBuilder.url(path, leadingSlash);
  },

  /**
   * Normalizes a URL for an API call for the various deployment configurations.
   * @param  {string} path         The path to normalize.
   * @param  {Boolean} [leadingSlash] True to include a leading slash, otherwise false. If unspecified, the input path will be examined, and its leading slash, or lack thereof, will be preserved. The trailing slash state is always preserved.
   * @return {String}              The normalized URL.
   * @example
   * UrlService.apiurl('/some/other/place');
   * //returns '/api/some/other/place' when running at root.
   * UrlService.apiurl('some/other/place', true);
   * //returns '/api/some/other/place' when running at root
   * UrlService.apiurl('');
   * //returns '/api' when running at root.
   * UrlService.apiurl('/somewhere', true, true);
   * //returns '/somewhere'
   * UrlService.apiurl('some/other/place', false);
   * //returns 'api/some/other/place'
   */
  apiurl: function (path, leadingSlash) {
    return this.apiBuilder.absolute().url(path, leadingSlash);
  },
};

export default new UrlService();



//////////////////
// WEBPACK FOOTER
// ./public/js/app/UrlService.js
// module id = 13
// module chunks = 1